// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./components/accordion/style/index.less
 ** module id = 284
 ** module chunks = 0
 **/